export default "__VITE_ASSET__7Uux17SM__"